import {SocialAuthService} from '@abacritt/angularx-social-login';
import {Directive, ElementRef, Input, OnChanges, OnInit} from '@angular/core';
import {take} from 'rxjs';
import {PlatformService} from '../services/platform-service.service';

declare var google;

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'google-signin-butt',
  standalone: true
})
export class GoogleSigninButtDirective implements OnInit, OnChanges {

  @Input('selectable') option: boolean;
  @Input() public isCliked;

  constructor(private el: ElementRef,
              private platformService: PlatformService,
              private socialAuthService: SocialAuthService,
  ) {
  }

    ngOnInit() {
        if (!this.option) return;
        this.socialAuthService.initState.pipe(take(1)).subscribe(() => {
            google.accounts.id.renderButton(
              document.getElementById('google'),
               {
                 type: 'icon',
                 size: 'large',
                 text: 'signin_with',
                 theme: 'filled_blue',
                 logo_alignment: 'center',

               });
        });
    }

  ngOnChanges(changes) {
    if (changes.isCliked && changes.isCliked.currentValue == true) {
      this.createFakeGoogleWrapper();
    }
  }

  createFakeGoogleWrapper() {
    if (this.platformService.isBrowserPlatform()) {
      const googleLoginWrapper = document.createElement('div');
      googleLoginWrapper.style.display = 'none';
      googleLoginWrapper.classList.add('custom-google-button');
      document.body.appendChild(googleLoginWrapper);
      google.accounts.id.renderButton(googleLoginWrapper, {
        type: 'icon',
          width: '200',
      });

      const googleLoginWrapperButton = googleLoginWrapper.querySelector(
          'div[role=button]'
      ) as HTMLElement;
      googleLoginWrapperButton?.click();
    }
  }

}
